import API from "./api";

// ===============================
// 🟢 BOOKING SYSTEM (NEW SAFE LAYER)
// ===============================

export const initiateBookingPayment = async (data) => {
  const res = await API.post("/booking/initiate", data);
  return res.data;
};

export const verifyBookingPayment = async (transaction_id) => {
  const res = await API.get("/booking/verify", {
    params: { transaction_id },
  });
  return res.data;
};